<template>
  <v-dialog v-model="openDialog" width="1700px" persistent scrollable>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <mf-search id="category-label" placeholder="Selecione a categoria" hide-details :value="textFieldValue" />
      </div>
    </template>
    <v-card v-if="openDialog">
      <v-card-title>
        <span class="mf-h6 primary-text">{{ title }}</span>
      </v-card-title>
      <v-card-text class="select-categories">
        <v-row no-gutters>
          <v-col cols="9" class="light-background">
            <category-tree-content :picked-items.sync="categories" />
          </v-col>
          <v-col cols="3" class="dark-background">
            <selected-categories :selected-categories.sync="categories" :max-selectable-items="maxCategories" />
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Confirmar',
            action: selectCategories,
            isVisible: true,
            isDisabled: isComparativeDisabled,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SelectCategoriesModal',
  components: {
    CategoryTreeContent: () => import('@/components/select-categories-modal/CategoryTreeContent.vue'),
    SelectedCategories: () => import('@/components/select-categories-modal/SelectedCategories.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    openDialog: false,
    categories: [],
    maxCategories: 20,
  }),
  computed: {
    textFieldValue() {
      if (!this.selectedCategories.length) return 'Escolher categorias'
      return this.selectedCategories.length === 1 ? '1 selecionada' : `${this.selectedCategories.length} selecionadas`
    },
    selectedCategories: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    title() {
      return `Selecionar categorias (máximo ${this.maxCategories})`
    },
    isComparativeDisabled() {
      return this.categories.length > this.maxCategories
    },
  },
  watch: {
    value(value) {
      this.categories = value
    },
    openDialog(value) {
      if (value) {
        this.categories = this.value
      }
    },
  },
  mounted() {
    if (this.value) this.categories = this.value
  },
  methods: {
    closeDialog() {
      this.openDialog = false
    },
    selectCategories() {
      this.selectedCategories = this.categories
      this.closeDialog()
    },
    clearCategories() {
      this.categories = []
    },
  },
}
</script>

<style lang="scss" scoped>
.select-categories {
  .light-background {
    background-color: $cinza-l90;
  }
  .dark-background {
    background-color: $cinza-l80;
  }
}
</style>
